module.exports = __webpack_public_path__ + "static/media/main1_zh.6ca11806.png";